import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import utils from '../../../../../lib/utils';
import CustomSelection from '../../../../CustomSelection';
import CustomValidationInput from '../../../../CustomValidationInput';
import Table from '../../../../Table';
import { forwardPortObject, filterOptions } from './constants';
const PortForwardUpdate = ({ portForwardList, callback }) => {
  const [forwardPortList, setForwardPortList] = useState([]);
  const [hit, setHit] = useState(false);

  useEffect(() => {
    const portArray = [];

    portForwardList.forEach((item, index) => {
      if (!!item.srcIP) {
        portArray.push({
          ...forwardPortObject,
          submit: !!item.srcIP,
          dstEndPort: item.dstEndPort,
          dstStartPort: item.dstStartPort,
          dstIP: item.dstIP,
          srcIP: item.srcIP,
          srcEndPort: item.srcEndPort,
          srcStartPort: item.srcStartPort,
          proto: item.proto,
          srcIPValid: true,
          dstIPValid: true,
          srcStartPortValid: true,
          srcEndPortValid: true,
          dstStartPortValid: true,
          dstEndPortValid: true,
          protoValid: true,
        });
      } else {
        portArray.push({
          ...forwardPortObject,
          submit: !!item.srcIP,
          dstEndPort: item.dstEndPort,
          dstStartPort: item.dstStartPort,
          dstIP: item.dstIP,
          srcIP: item.srcIP,
          srcEndPort: item.srcEndPort,
          srcStartPort: item.srcStartPort,
          proto: item.proto,
        });
      }
    });
    setForwardPortList(portArray);
    setHit(true);
  }, []);
  const submitStatus = () => {
    let indexOf = null;
    for (let [i, v] of forwardPortList.entries()) {
      if (!v.submit) {
        indexOf = i;
        break;
      }
    }
    forwardPortList[indexOf].submit = true;
    setForwardPortList(forwardPortList);
    setHit(false);
  };
  useMemo(() => {
    hit && submitStatus();
  }, [forwardPortList, portForwardList]);

  const handleIpChange = (ev, index) => {
    const { name, value } = ev.currentTarget;
    const obj = forwardPortList[index];
    const updatedObj = { ...obj, [name]: value };

    updateForwardList(updatedObj, index);
    if (name === 'srcIP' || name === 'dstIP') {
      if (utils.validateIPaddress(value)) {
        const updatedObj = {
          ...obj,
          [`${name}Message`]: 'Valid',
          [`${name}Valid`]: true,
          [name]: value,
        };
        updateForwardList(updatedObj, index);
      } else {
        const updatedObj = {
          ...obj,
          [`${name}Message`]: 'Invalid',
          [`${name}Valid`]: false,
          [name]: value,
        };
        updateForwardList(updatedObj, index);
      }
    } else {
      if (!!value) {
        const updatedObj = {
          ...obj,
          [`${name}Valid`]: true,
          [name]: value,
        };
        updateForwardList(updatedObj, index);
      } else {
        const updatedObj = {
          ...obj,
          [`${name}Valid`]: false,
          [name]: value,
        };
        updateForwardList(updatedObj, index);
      }
    }
  };

  const handleStartEndChange = (ev, index) => {
    const { name, value } = ev.currentTarget;
    const obj = forwardPortList[index];
    const updatedObj = { ...obj, [name]: value };

    updateForwardList(updatedObj, index);

    const srcTest = name.includes('src') && name.includes('End');
    const dstTest = name.includes('dst') && name.includes('End');

    if (isNaN(value)) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'Please enter a number',
        [`${name}Valid`]: false,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    } else if (!value || Number(value) < 1) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'Value cannot be empty or less than 0',
        [`${name}Valid`]: false,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    } else if (srcTest && !obj['srcStartPort']) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'Please enter start port first',
        [`${name}Valid`]: false,
      };
      updateForwardList(updatedObj, index);
    } else if (dstTest && !obj['dstStartPort']) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'Please enter start port first',
        [`${name}Valid`]: false,
      };
      updateForwardList(updatedObj, index);
    } else if (srcTest && Number(value) <= Number(obj['srcStartPort'])) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'End port should be greater then start port',
        [`${name}Valid`]: false,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    } else if (dstTest && !obj['srcEndPort']) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'You cannot add until you add src end port',
        [`${name}Valid`]: false,
      };
      updateForwardList(updatedObj, index);
    } else if (dstTest && Number(value) <= Number(obj['dstStartPort'])) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'End port should be greater then start port',
        [`${name}Valid`]: false,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    } else if (srcTest && Number(value) > 65535) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'End port should be less then 65535',
        [`${name}Valid`]: false,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    } else if (dstTest && Number(value) > 65535) {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'End port should be less then 65535',
        [`${name}Valid`]: false,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    } else {
      const updatedObj = {
        ...obj,
        [`${name}Message`]: 'Valid',
        [`${name}Valid`]: true,
        [name]: value,
      };
      updateForwardList(updatedObj, index);
    }
  };

  const updateForwardList = (updatedObj, index) => {
    setForwardPortList([
      ...forwardPortList.slice(0, index),
      updatedObj,
      ...forwardPortList.slice(index + 1),
    ]);
  };

  const onFocusInput = (type, index) => {
    const obj = forwardPortList[index];
    if (!!obj[type]) {
      if (type === 'srcIP' || type === 'dstIP') {
        if (!!obj[type] && utils.validateIPaddress(obj[type])) {
          const updatedObj = {
            ...obj,
            [`${type}Message`]: 'Valid',
            [`${type}Valid`]: true,
            [`${type}ShowMsg`]: true,
          };
          updateForwardList(updatedObj, index);
        } else {
          const updatedObj = {
            ...obj,
            [`${type}Message`]: 'Invalid',
            [`${type}Valid`]: false,
            [`${type}ShowMsg`]: true,
          };
          updateForwardList(updatedObj, index);
        }
      } else {
        const updatedObj = {
          ...obj,
          [`${type}Message`]: 'Valid',
          [`${type}Valid`]: true,
          [`${type}ShowMsg`]: true,
        };
        updateForwardList(updatedObj, index);
      }
    } else {
      const updatedObj = {
        ...obj,
        [`${type}Valid`]: false,
        [`${type}ShowMsg`]: true,
      };
      updateForwardList(updatedObj, index);
    }
  };

  const onBlurInput = (type, index) => {
    const obj = forwardPortList[index];
    const updatedObj = {
      ...obj,
      [`${type}ShowMsg`]: false,
    };
    updateForwardList(updatedObj, index);
  };

  const validObject = (index, endStatus) => {
    const {
      dstIPValid,
      srcIPValid,
      srcStartPortValid,
      dstStartPortValid,
      srcEndPortValid,
      dstEndPortValid,
      protoValid,
    } = forwardPortList[index];

    const validObj = {
      dstIPValid,
      srcIPValid,
      protoValid,
      srcStartPortValid,
      dstStartPortValid,
      srcEndPortValid,
      dstEndPortValid,
    };

    if (endStatus) {
      delete validObj.srcEndPortValid;
      delete validObj.dstEndPortValid;
    }

    return Object.keys(validObj).every(k => validObj[k]);
  };

  const onSavePort = async (index, actionStatus) => {
    const {
      srcIP,
      srcStartPort,
      srcEndPort,
      dstStartPort,
      dstEndPort,
      dstIP,
      proto,
    } = forwardPortList[index];

    const portObject = {
      srcIP,
      srcStartPort,
      srcEndPort,
      dstIP,
      dstStartPort,
      dstEndPort,
      proto,
      action: 'addRule',
    };

    if (actionStatus === 'update') {
      delete portObject.action;
    }

    const difference =
      Number(srcEndPort) - Number(srcStartPort) !== Number(dstEndPort) - Number(dstStartPort);

    // srcEndPort and dstEndPort are not empty then srcEndPort minus srcStartPort should equal to dstEndPort minus dstStartPort

    if (!!srcEndPort && !!dstEndPort && difference) {
      toast.error('Difference between src and dst ports should be same');
    } else if (validObject(index, !srcEndPort && !dstEndPort)) {
      callback(portObject, actionStatus, index);
    } else toast.error('Please enter valid values');
  };

  const onDeletePort = index => {
    const {
      srcIP,
      srcStartPort,
      srcEndPort,
      dstStartPort,
      dstEndPort,
      dstIP,
      proto,
    } = portForwardList[index];

    const portObject = {
      srcIP,
      srcStartPort,
      srcEndPort,
      dstIP,
      dstStartPort,
      dstEndPort,
      proto,
      action: 'removeRule',
    };
    callback(portObject, 'delete');
  };

  const column = [
    {
      dataIndex: 'srcIP',
      label: 'Source IP',
      render: (_, datum, index) => {
        return (
          <CustomValidationInput
            disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
            placeholder="Please specify"
            value={forwardPortList[index].srcIP}
            name="srcIP"
            onChange={e => handleIpChange(e, index)}
            validStatus={forwardPortList[index].srcIPValid}
            messageText={forwardPortList[index].srcIPMessage}
            messageStatus={forwardPortList[index].srcIPShowMsg}
            onFocus={() => onFocusInput('srcIP', index)}
            onBlur={() => onBlurInput('srcIP', index)}
          />
        );
      },
    },
    {
      dataIndex: 'sourceStrtEndPort',
      label: 'Source Start End Port',
      render: (_, datum, index) => {
        return (
          <div className="input-row" tabIndex={1}>
            <CustomValidationInput
              disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
              placeholder="Please specify"
              value={forwardPortList[index].srcStartPort}
              name="srcStartPort"
              onChange={e => handleStartEndChange(e, index)}
              validStatus={forwardPortList[index].srcStartPortValid}
              messageText={forwardPortList[index].srcStartPortMessage}
              messageStatus={forwardPortList[index].srcStartPortShowMsg}
              onFocus={() => onFocusInput('srcStartPort', index)}
              onBlur={() => onBlurInput('srcStartPort', index)}
            />
            <CustomValidationInput
              disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
              placeholder="Please specify"
              value={forwardPortList[index].srcEndPort}
              name="srcEndPort"
              onChange={e => handleStartEndChange(e, index)}
              validStatus={forwardPortList[index].srcEndPortValid}
              messageText={forwardPortList[index].srcEndPortMessage}
              messageStatus={forwardPortList[index].srcEndPortShowMsg}
              onFocus={() => onFocusInput('srcEndPort', index)}
              onBlur={() => onBlurInput('srcEndPort', index)}
            />
          </div>
        );
      },
    },
    {
      dataIndex: 'dstIP',
      label: 'Destination IP',
      render: (_, datum, index) => {
        return (
          <CustomValidationInput
            disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
            placeholder="Please specify"
            value={forwardPortList[index].dstIP}
            name="dstIP"
            onChange={e => handleIpChange(e, index)}
            validStatus={forwardPortList[index].dstIPValid}
            messageText={forwardPortList[index].dstIPMessage}
            messageStatus={forwardPortList[index].dstIPShowMsg}
            onFocus={() => onFocusInput('dstIP', index)}
            onBlur={() => onBlurInput('dstIP', index)}
          />
        );
      },
    },
    {
      dataIndex: 'destinationStrtEndPort',
      label: 'Destination Start End Port',
      render: (_, datum, index) => {
        return (
          <div className="input-row">
            <CustomValidationInput
              disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
              placeholder="Please specify"
              value={forwardPortList[index].dstStartPort}
              name="dstStartPort"
              onChange={e => handleStartEndChange(e, index)}
              validStatus={forwardPortList[index].dstStartPortValid}
              messageText={forwardPortList[index].dstStartPortMessage}
              messageStatus={forwardPortList[index].dstStartPortShowMsg}
              onFocus={() => onFocusInput('dstStartPort', index)}
              onBlur={() => onBlurInput('dstStartPort', index)}
            />

            <CustomValidationInput
              disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
              placeholder="Please specify"
              value={forwardPortList[index].dstEndPort}
              name="dstEndPort"
              onChange={e => handleStartEndChange(e, index)}
              validStatus={forwardPortList[index].dstEndPortValid}
              messageText={forwardPortList[index].dstEndPortMessage}
              messageStatus={forwardPortList[index].dstEndPortShowMsg}
              onFocus={() => onFocusInput('dstEndPort', index)}
              onBlur={() => onBlurInput('dstEndPort', index)}
            />
          </div>
        );
      },
    },
    {
      dataIndex: 'proto',
      label: 'Type',
      render: (_, datum, index) => {
        return (
          <CustomSelection
            disabled={!forwardPortList[index].enable || !forwardPortList[index].submit}
            name="proto"
            placeholder
            value={forwardPortList[index].proto}
            onChange={e => handleIpChange(e, index)}
            optionsList={filterOptions}
          />
        );
      },
    },
    {
      dataIndex: 'submit',
      label: '',
      render: (_, datum, index) => {
        return !!portForwardList[index].srcIP ? (
          <>
            <Button
              disabled={!forwardPortList[index].submit}
              color="primary"
              className="btn-action"
              onClick={() => onSavePort(index, 'update')}
            >
              Update
            </Button>
            <Button
              disabled={!forwardPortList[index].submit}
              color="danger"
              className="btn-action"
              onClick={() => onDeletePort(index)}
            >
              Delete
            </Button>
          </>
        ) : (
          <Button
            disabled={!forwardPortList[index].submit}
            color="primary"
            className="btn-action"
            onClick={() => onSavePort(index, 'save')}
          >
            Save
          </Button>
        );
      },
    },
  ];
  return <Table data={forwardPortList} column={column} showPagination />;
};

const mapStateToProps = state => ({
  store: state,
  user: state.AppState.user,
  portForwardList: state.AppState.boxDetails.portForwardList,
});
export default connect(
  mapStateToProps,
  null,
)(PortForwardUpdate);
